import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { VenetianBlinds25 } from './VenetianBlinds25';
import { VenetianBlinds50 } from './VenetianBlinds50';
import { VenetianBlinds63 } from './VenetianBlinds63';

export const VenetianBlinds = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const {
      custom: { slatSize },
    } = state.context;
    const patterUrl = getPatternImages(state);

    switch (slatSize) {
      case '63mm':
        return <VenetianBlinds63 patternUrl={patterUrl} {...props} />;
      case '50mm':
        return <VenetianBlinds50 patternUrl={patterUrl} {...props} />;
      case '25mm':
      default:
        return <VenetianBlinds25 {...props} ref={setProductImageRef} />;
    }
  },
);
